export default "__VITE_ASSET__BgYyGLVw__"